export function move(){
    var curSlide = $('.team .slides li.flex-active-slide'); 
    var h3 = curSlide.find('h3'),
    p = curSlide.find('p'),
    img = curSlide.find('img'); 
    h3.addClass( h3.data ('animate'));
    p.addClass( p.data('animate'));
    img.each(function(){
        $(this).addClass($(this).data('animate')).css({'animation-delay': $(this).data('delay')+'s'});
    })
}

export function initState(){
    $('.team .animated').each(function(){
        var dataAnimate = $(this).data('animate');
        $(this).removeClass(dataAnimate);
    })
}

//联系我们
//创建和初始化地图函数：
export function initMap(){
    createMap();//创建地图
    setMapEvent();//设置地图事件
    addMapOverlay();//向地图添加覆盖物
  }
export  function createMap(){ 
    map = new BMap.Map("map"); 
    map.centerAndZoom(new BMap.Point(113.233998,23.133447),17);//106.575711,29.531776
  }
export  function setMapEvent(){
    map.enableScrollWheelZoom();
    map.enableKeyboard();
    map.enableDragging();
    map.enableDoubleClickZoom()
  }
export  function addClickHandler(target,window){
    target.addEventListener("click",function(){
      target.openInfoWindow(window);
    });
  }
export function addMapOverlay(){
    var markers = [
      {content:"",title:"",imageOffset: {width:-46,height:-21},position:{lat:23.133447,lng:113.233998}}
    ];
    for(var index = 0; index < markers.length; index++ ){
      var point = new BMap.Point(markers[index].position.lng,markers[index].position.lat);
      var marker = new BMap.Marker(point,{icon:new BMap.Icon("http://api.map.baidu.com/lbsapi/createmap/images/icon.png",new BMap.Size(20,25),{
        imageOffset: new BMap.Size(markers[index].imageOffset.width,markers[index].imageOffset.height)
      })});
      var label = new BMap.Label(markers[index].title,{offset: new BMap.Size(25,5)});
      var opts = {
        width: 200,
        title: markers[index].title,
        enableMessage: false
      };
      var infoWindow = new BMap.InfoWindow(markers[index].content,opts);
      marker.setLabel(label);
      addClickHandler(marker,infoWindow);
      map.addOverlay(marker);
    };
  }
  //向地图添加控件
export  function addMapControl(){
    var scaleControl = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
    scaleControl.setUnit(BMAP_UNIT_IMPERIAL);
    map.addControl(scaleControl);
    var navControl = new BMap.NavigationControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT,type:0});
    map.addControl(navControl);
    var overviewControl = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:true});
    map.addControl(overviewControl);
  }


/**
 * 获取新闻列表
 * @param {*} vueobj vue实例
 * @param {*} typecode 新闻类型
 * @param {*} pageNum 当前页
 */
export function getNewsList(vueobj,typecode,pageNum){
  return vueobj.$get("/api/xzsoft/website/xwdt/getNewsList",{typecode:typecode,pageNum:pageNum})
} 

/**
 * 获取客户案例列表
 * @param {*} vueobj vue实例
 * @param {*} typecode 案例类型
 * @param {*} pageNum 当前页
 */
export function getCustomerCaseList(vueobj,typecode,pageNum){
  return vueobj.$get("/api/xzsoft/website/khal/getCustomerCaseList",{typecode:typecode,pageNum:pageNum})
} 

/**
 * 知识产权列表
 * @param {*} vueobj vue实例
 * @param {*} typecode 产权类型
 * @param {*} pageNum 当前页
 */
export function getIntellectualPropertyList(vueobj,typecode,pageNum){
  return vueobj.$get("/api/xzsoft/website/zscq/getIntellectualPropertyList",{typecode:typecode,pageNum:pageNum})
} 

/**
 * 获取轮播图
 * @param {*} vueobj 
 * @param {*} menuType 菜单
 */
export function getBanner(vueobj,menuType){
  return vueobj.$get("/api/xzsoft/website/common/getBanner",{menuType:menuType})
} 

//getCustomerCaseList



// WEBPACK FOOTER //
// ./src/assets/Scripts/fn.js